// @ts-ignore
import {Handler, Chunker, Polisher} from "pagedjs";

export class PagedJsReportHandler extends Handler {
    constructor(chunker: Chunker, polisher: Polisher, caller: any) {
        super(chunker, polisher, caller);
    }

    // Previewer events
    beforePreview(content: any, renderTo: any) {
        console.log("beforePreview");
    }
    afterPreview(pages: any) {
        console.log("afterPreview");
    }

    // Chunker events
    beforeParsed(content: any) {
        console.log("beforeParsed");
    }

    afterParsed(parsed: any) {
        console.log("afterParsed");
    }

    beforePageLayout(page: any) {
        console.log("beforePageLayout");
    }

    afterPageLayout(pageElement: any, page: any, breakToken: any) {
        console.log("afterPageLayout");
    }

    afterRendered(pages: any) {
        console.log("afterRendered");
    }

    // Polisher events
    beforeTreeParse(text: any, sheet: any) {
        console.log("beforeTreeParse");
    }

    beforeTreeWalk(ast: any) {
        console.log("beforeTreeWalk");
    }

    afterTreeWalk(ast: any, sheet: any) {
        console.log("afterTreeWalk");
    }

    onUrl(urlNode: any) {
        console.log("onUrl");
    }

    onAtPage(atPageNode: any) {
        console.log("onAtPage");
    }

    onRule(ruleNode: any) {
        console.log("onRule");
    }

    onDeclaration(declarationNode: any, ruleNode: any) {
        console.log("onDeclaration");
    }

    onContent(contentNode: any, declarationNode: any, ruleNode: any, sheet: any) {
        console.log("onContent");
    }

    // Layout events
    layoutNode(node: any) {
        console.log(`layoutNode`);
    }

    renderNode(node: any, sourceNode: any) {
        console.log(`renderNode`);
    }

    onOverflow(overflow: any, rendered: any, bounds: any) {
        console.log("onOverflow");
    }

    onBreakToken(breakToken: any, overflow: any, rendered: any) {
        console.log("onBreakToken");
    }
}